/**
 * Logica pura della "Nuova chat" (niente React ne' Supabase: i test girano in node).
 */
import { isItalianMobileWithoutPrefix, normalizeWhatsAppDigits } from './phoneDigits';
import { looksLikePhoneNumber } from './chatListRules';

export type NewChatQuery =
  | { kind: 'empty' }
  | { kind: 'phone'; digits: string }
  | { kind: 'name'; term: string };

/** Cosa ha scritto l'utente nel campo unico: un numero da contattare o un nome da cercare fra Lead e Clienti. */
export function classifyNewChatQuery(text: string | null | undefined): NewChatQuery {
  const t = (text || '').trim();
  if (!t) return { kind: 'empty' };
  if (looksLikePhoneNumber(t)) {
    const digits = normalizeWhatsAppDigits(t);
    if (digits.length >= 8) return { kind: 'phone', digits };
  }
  return { kind: 'name', term: t };
}

export interface ClientPhoneFields {
  phone?: string | null;
  whatsapp_number?: string | null;
  country_code?: string | null;
}

/** Un numero salvato nella scheda: col prefisso gia' scritto si usa com'e', altrimenti si antepone country_code. */
function toDigits(raw: string | null | undefined, countryCode: string | null | undefined): string {
  const value = (raw || '').trim();
  if (!value) return '';
  if (value.startsWith('+') || value.startsWith('00')) return normalizeWhatsAppDigits(value);
  const cc = (countryCode || '').replace(/\D/g, '');
  const local = value.replace(/\D/g, '');
  // Un cellulare italiano di 10 cifre che inizia per 39x non ha gia' il prefisso.
  const hasPrefix = local.startsWith(cc) && !(cc === '39' && isItalianMobileWithoutPrefix(local));
  if (cc && local && !hasPrefix) return normalizeWhatsAppDigits(`+${cc}${local}`);
  return normalizeWhatsAppDigits(value);
}

/** Numeri WhatsApp possibili di un Lead/Cliente, senza doppioni: prima il numero WhatsApp, poi il telefono. */
export function clientWhatsAppNumbers(client: ClientPhoneFields): string[] {
  const out: string[] = [];
  for (const raw of [client.whatsapp_number, client.phone]) {
    const digits = toDigits(raw, client.country_code);
    if (digits.length >= 8 && !out.includes(digits)) out.push(digits);
  }
  return out;
}

export type ServiceName = 'waha' | 'whatsapp_cloud' | 'whatsapp_cloud_coex' | string;

/**
 * Solo le sessioni WAHA sanno dire se un numero ha WhatsApp; sui numeri ufficiali (Cloud) non si verifica.
 * Unica definizione in chatCapabilities.ts, riesportata qui per chi la importava da questo file.
 */
export { isCloudService } from './chatCapabilities';

export type CheckOutcome = 'open' | 'missing' | 'unknown';

/** Esito della verifica WAHA: exists=null vuol dire "non sono riuscito a verificare". */
export function outcomeOfCheck(result: { exists: boolean | null } | null | undefined): CheckOutcome {
  if (!result || result.exists === null) return 'unknown';
  return result.exists ? 'open' : 'missing';
}
